import { useQuery, useQueryClient } from "@tanstack/react-query";

export const savedBrowserTaskQueries = {
  all: (threadId: number) => ["threads", threadId, "savedBrowserTasks"] as const,
};

const savedBrowserOpenKey = (threadId: number) =>
  ["threads", threadId, "savedBrowserOpenIntent"] as const;
type OpenIntent = { taskId: string; requestedAtMs: number } | null;
/** Viewer intent is device-local and never contains a browser bearer URL. */
export function rememberSavedBrowserOpen(
  client: ReturnType<typeof useQueryClient>,
  threadId: number,
  taskId: string,
): void {
  client.setQueryData<OpenIntent>(savedBrowserOpenKey(threadId), {
    taskId,
    requestedAtMs: Date.now(),
  });
  void client.invalidateQueries({ queryKey: ["threads", threadId, "browserTakeover"] });
  void client.invalidateQueries({ queryKey: savedBrowserTaskQueries.all(threadId) });
}
export function useSavedBrowserOpenIntent(threadId: number) {
  const client = useQueryClient();
  const { data } = useQuery<OpenIntent>({
    queryKey: savedBrowserOpenKey(threadId),
    queryFn: () => null,
    initialData: null,
    enabled: false,
  });
  return {
    intent: data,
    consume: () => client.setQueryData<OpenIntent>(savedBrowserOpenKey(threadId), null),
  };
}
